var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
// 検証用のコンポーネント
var KtsVerificationComponent = /** @class */ (function (_super) {
    __extends(KtsVerificationComponent, _super);
    function KtsVerificationComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    KtsVerificationComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsVerificationComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsVerificationComponent.prototype.onEvent = function (e1, e2, r) {
    };
    KtsVerificationComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-verification',
                    template: "<div id=\"{{ componentName }}\">\n  <p class=\"-comment -mb-1\">\u203B\u65E5\u6642\u9078\u629E\u306E\u30E9\u30A4\u30D6\u30E9\u30EA\u3092\u691C\u8A3C\u3059\u308B\u305F\u3081\u306E\u30DA\u30FC\u30B8\u3067\u3059\u3002</p>\n  <div class=\"row -mb-1\">\n    <div class=\"col-sm-12\">\n      <kts-column-pickadate></kts-column-pickadate>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <kts-column-flatpickr></kts-column-flatpickr>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsVerificationComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return KtsVerificationComponent;
}(ContentBaseComponent));
export { KtsVerificationComponent };
//# sourceMappingURL=verification.component.js.map